import {Content} from "#/src/pages/(profile)/profile/@id/Content";
import {Header} from "#/src/pages/(profile)/my-profile/Header";
import {LiveStreamersHeader} from "#/src/components/LiveStreamersHeader";

export {Page}

function Page() {
  return <>
    <LiveStreamersHeader/>
    <Header/>
    <Content/>
  </>
}